export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5479.9b60e34e.jpg";